import React from "react";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {  faPhone } from '@fortawesome/free-solid-svg-icons';
// import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
// import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import Navbar from "../Navbar";
import Header from "../Header";
import Card from "../Card";
import Sdata from "../Servicedata";
import Destination from "../DestinationCard";
import Ddata from "../Destinationdata";
import time from "../assets/time.svg";
import money from "../assets/money.svg";
import network  from "../assets/network.svg";
import plan from "../assets/plan.svg";
import QueryForm from "../Queryform";
import ScrollToTop from "../ScrollToTop";
import Footer from "../Footer";
import TopHeader from "../TopHeader";

const Home = () => {
    return(
        <>

        {/* <div className="home-top-header">

        <div className="top-header-details">

        <div className="top-header-email">
        <FontAwesomeIcon icon={faEnvelope}  className="top-social-icon"/>
        <h3>tripanddroptravels@gmail.com</h3>
        </div>

        <div className="top-header-phone">
        <FontAwesomeIcon icon={faPhone} style={{color:'white'}} className="top-social-icon"/>
         <h3>+91 9999116868</h3>
        </div>

        </div>

        <div className="top-social">
            <h3>Follow Us :</h3>
            <a href="https://www.facebook.com/tripanddroptravels/" target="_blank"  rel="noreferrer"><FontAwesomeIcon icon={faFacebook} /></a>
           <a href="https://www.instagram.com/tripanddroptravels/" target="_blank"  rel="noreferrer"><FontAwesomeIcon icon={faInstagram}/></a> 
        </div>

        </div> */}

        <TopHeader/>

        <Navbar/>
        <div style={{padding:'2vh 6vh'}}>
        <Header/>
        </div>


      <div id="#aboutus" class='first-content'>   
      <h1 class='heading'>Welcome to Trip and Drop Travels Pvt. Ltd.</h1>   
  
       <p class='content'>Your Trusted Partner for Visa, Flights & Tour Packages</p>
     
       <div class='paraspace'>
       <p class="bodytext">At <strong>Trip and Drop</strong>, we make your travel dreams a reality. From visa services and air ticket bookings to customized tour packages across the world — we handle it all, so you can travel stress-free and with confidence.</p>
       </div>
     
     
      </div>


   <div class='service-section'>

    <div class='service-line-height'>
     <h1 class='service-heading'> Our Specialities</h1>
     </div> 
     <div class='card-align'>
     <Card img={Sdata[0].img} heading={Sdata[0].heading} para={Sdata[0].para}/>
     <Card img={Sdata[1].img} heading={Sdata[1].heading} para={Sdata[1].para}/>
     <Card img={Sdata[2].img} heading={Sdata[2].heading} para={Sdata[2].para}/>
    </div>
    <div class='card-align align2'>
     <Card img={Sdata[3].img} heading={Sdata[3].heading} para={Sdata[3].para}/>
     <Card img={Sdata[4].img} heading={Sdata[4].heading} para={Sdata[4].para}/>
     <Card img={Sdata[5].img} heading={Sdata[5].heading} para={Sdata[5].para}/>
    </div>
   

   </div>


   <div className="destination-package">
    <h2>Top  Destinations</h2>

   <div className="intl-package">
    <h3>International</h3>
    <div>
     <Destination img={Ddata[0].img} place={Ddata[0].place}/>
     <Destination img={Ddata[1].img} place={Ddata[1].place}/>
     <Destination img={Ddata[2].img} place={Ddata[2].place}/>
     <Destination img={Ddata[3].img} place={Ddata[3].place}/>
    </div>
   </div>

    <div className="domestic-package">
    <h3>Domestic</h3>
    <div>
     <Destination img={Ddata[4].img} place={Ddata[4].place}/>
     <Destination img={Ddata[5].img} place={Ddata[5].place}/>
     <Destination img={Ddata[6].img} place={Ddata[6].place}/>
     <Destination img={Ddata[7].img} place={Ddata[7].place}/>
    </div>

    </div>
    
   </div>


   <div className="why-container">
    <h2>Why Choose Us</h2>
    <div className="usp">
        <div >
            <img src={time} alt="why us"/>
            <h4><strong>Save Time </strong>: All services under one roof</h4>
        </div>
        <div >
            <img src={money} alt="why us"/>
            <h4><strong>Save Money </strong>: Get the best deals from multiple options</h4>
        </div>
        <div >
            <img src={network} alt="why us"/>
            <h4><strong>Trusted Network </strong>: 7,000+ verified agents and global partners</h4>
        </div>
        <div >
            <img src={plan} alt="why us"/>
            <h4><strong>Customized Plans </strong>: Travel your way — personalized, flexible & fun!</h4>
        </div>
    </div>
   </div>


   <h2 id="#contactus" className='contactus-heading'> Contact Us</h2>
  <div class='get-touch'> 
  
   <QueryForm/>
     <div class='map'>
   <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.4293241997243!2d77.09111109999999!3d28.646861099999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xb0a4b6549860ef1%3A0xbab220e01e65b41f!2sTrip%20and%20Drop%20Travels%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1749367138786!5m2!1sen!2sin" width="650" height="500"  allowfullscreen="" loading="lazy" title="Trip and Drop" referrerpolicy="no-referrer-when-downgrade"></iframe>
     </div>
     </div>
     
     <ScrollToTop />
     <Footer />


        </>
    );
}

export default Home;